import { render, staticRenderFns } from "./Sleepwell.vue?vue&type=template&id=dcd6595c&lang=pug"
import script from "./Sleepwell.js?vue&type=script&lang=js&external"
export * from "./Sleepwell.js?vue&type=script&lang=js&external"
import style0 from "./Sleepwell.vue?vue&type=style&index=0&id=dcd6595c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports